import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "changePassword",
    serviceName: "unitadmin",
    query: gql`
      mutation changePassword($user_ids: [String]!, $password: String) {
        changePassword(user_ids: $user_ids, password: $password) {
          messages
        }
      }
    `,
  },
};

export default schema;
